export function ListViewIcon({ className }: { className?: string }) {
  return (
    <div style={{ padding: "4px" }}>
      <svg
        className={className}
        width="24"
        height="24"
        viewBox="0 0 18 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 1.5C0 0.672 0.666 0 1.5 0C2.328 0 3 0.666 3 1.5C3 2.328 2.334 3 1.5 3C0.672 3 0 2.334 0 1.5ZM7.5 0H16.5C16.8978 0 17.2794 0.158036 17.5607 0.43934C17.842 0.720645 18 1.10218 18 1.5C18 1.89782 17.842 2.27936 17.5607 2.56066C17.2794 2.84196 16.8978 3 16.5 3H7.5C7.10218 3 6.72064 2.84196 6.43934 2.56066C6.15804 2.27936 6 1.89782 6 1.5C6 1.10218 6.15804 0.720645 6.43934 0.43934C6.72064 0.158036 7.10218 0 7.5 0V0ZM0 7.5C0 6.672 0.666 6 1.5 6C2.328 6 3 6.666 3 7.5C3 8.328 2.334 9 1.5 9C0.672 9 0 8.334 0 7.5ZM7.5 6H16.5C16.8978 6 17.2794 6.15804 17.5607 6.43934C17.842 6.72064 18 7.10218 18 7.5C18 7.89782 17.842 8.27936 17.5607 8.56066C17.2794 8.84196 16.8978 9 16.5 9H7.5C7.10218 9 6.72064 8.84196 6.43934 8.56066C6.15804 8.27936 6 7.89782 6 7.5C6 7.10218 6.15804 6.72064 6.43934 6.43934C6.72064 6.15804 7.10218 6 7.5 6V6ZM0 13.5C0 12.672 0.666 12 1.5 12C2.328 12 3 12.666 3 13.5C3 14.328 2.334 15 1.5 15C0.672 15 0 14.334 0 13.5ZM7.5 12H16.5C16.8978 12 17.2794 12.158 17.5607 12.4393C17.842 12.7206 18 13.1022 18 13.5C18 13.8978 17.842 14.2794 17.5607 14.5607C17.2794 14.842 16.8978 15 16.5 15H7.5C7.10218 15 6.72064 14.842 6.43934 14.5607C6.15804 14.2794 6 13.8978 6 13.5C6 13.1022 6.15804 12.7206 6.43934 12.4393C6.72064 12.158 7.10218 12 7.5 12V12Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
